import React from "react";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";

const ALERT_STYLE = {
  success: { backgroundColor: "#2e7d32", color: "#ffffff" },
  error: { backgroundColor: "#d32f2f", color: "#ffffff" },
};

/**
 * Top-center notice. Open, message, and severity come from the parent.
 * Closes after 5 seconds and when the close button is clicked.
 */
const TopSnackbar = ({ open, message, severity, onClose }) => {
  const handleClose = (_event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    onClose();
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={5000}
      onClose={handleClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
    >
      <Alert
        onClose={handleClose}
        severity={severity}
        variant="filled"
        sx={{
          ...(ALERT_STYLE[severity] || {}),
          borderRadius: "12px",
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default TopSnackbar;
